import React from "react";

const TONE_MAP = {
  pending: {
    bg: "bg-[#FEF4E2]",
    text: "text-[#F59E0B]",
    dot: "bg-[#F59E0B]",
  },
  approved: {
    bg: "bg-[#E2F8F6]",
    text: "text-[#0DBBB3]",
    dot: "bg-[#0DBBB3]",
  },
  rejected: {
    bg: "bg-[#FEE9EE]",
    text: "text-[#FC466C]",
    dot: "bg-[#FC466C]",
  },
  "in-progress": {
    bg: "bg-[#EEF2FB]",
    text: "text-[#4A6BB6]",
    dot: "bg-[#4A6BB6]",
  },
  expired: {
    bg: "bg-[#F8FAFC]",
    text: "text-[#64748B]",
    dot: "bg-[#94A3B8]",
  },
  default: {
    bg: "bg-[#F8FAFC]",
    text: "text-[#64748B]",
    dot: "bg-[#94A3B8]",
  },
};

const normalizeStatus = (status) => {
  const s = String(status || "").toLowerCase();
  if (s === "in-progress" || s === "in progress") return "in-progress";
  if (s === "expired") return "expired";
  if (s === "pending") return "pending";
  if (s === "approved") return "approved";
  if (s === "rejected") return "rejected";
  return "default";
};

const formatLabel = (status) => {
  if (!status) return "—";
  const s = String(status);
  if (s === "In-progress") return "In progress";
  return s.charAt(0).toUpperCase() + s.slice(1);
};

const TimesheetStatusPill = ({ status, className = "" }) => {
  const tone = TONE_MAP[normalizeStatus(status)] || TONE_MAP.default;

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ${tone.bg} ${tone.text} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${tone.dot}`} />
      {formatLabel(status)}
    </span>
  );
};

export default TimesheetStatusPill;
